module.exports = __webpack_public_path__ + "img/success.ad02d0c8.png";